import { render } from "./StocksGeneral.vue?vue&type=template&id=12eafdba&scoped=true"
import script from "./StocksGeneral.vue?vue&type=script&lang=js"
export * from "./StocksGeneral.vue?vue&type=script&lang=js"

import "./StocksGeneral.vue?vue&type=style&index=0&id=12eafdba&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12eafdba"]])

export default __exports__